import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileApi } from "../../api/profileApi";
import { handleRequest } from "../utils/handleRequest";
import { AppDispatch, RootState } from "../store";
import { CallResult } from "../../api/Requests";
import { Profile } from "../../authentication/model/Profile";
import i18n from "../../i18n";

export const fetchProfileThunk = createAsyncThunk<
  Profile,
  void,
  { dispatch: AppDispatch; state: RootState; rejectValue: string }
>(
  "profile/fetchProfile",
  async (_, { dispatch, rejectWithValue }) => {
    const callResult = await handleRequest(
      dispatch,
      "indirect",
      () => profileApi.getCurrentProfile()
    );
    if (!callResult.success()) {
      return rejectWithValue(callResult.errorMessage ?? "Failed to fetch profile");
    }
    return callResult.result as Profile;
  }
);

export const changePasswordThunk = createAsyncThunk<
  CallResult<any>,
  { userId: string; currentPassword: string; newPassword: string },
  { dispatch: AppDispatch; state: RootState }
>(
  "profile/changePassword",
  async ({ userId, currentPassword, newPassword }, { dispatch }) => {
    return await handleRequest(
      dispatch,
      "direct",
      () => profileApi.changePassword(userId, { currentPassword, newPassword }),
      i18n.t("requestMessage.passwordChanged")
    );
  }
);